import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const paymentTypes = Loadable(() => (isFuncComp() ? import('../../FuncContainers/web/paymentTypes') : import('../../containers/web/paymentTypes')));
export default MapTo('vcg/components/soe-home/react/paymentTypes')(paymentTypes);
